@if (lesson) {
<div class="w-full h-full flex flex-col">
  <!-- Header do PDF -->
  <app-lesson-header
    icon="bi-file-pdf"
    iconColor="text-red-500"
    [title]="lesson.title"
    [subtitle]="lesson.description"
  >
  </app-lesson-header>

  <!-- Visualizador de PDF ou Mensagem de Erro -->
  @if (safePdfUrl) {
  <div class="flex-1 min-h-0">
    <iframe
      class="w-full h-full block"
      [src]="safePdfUrl"
      [title]="lesson.title"
      frameborder="0"
      allow="fullscreen"
      loading="lazy"
    >
    </iframe>
  </div>
  } @else {
  <div
    class="flex-1 min-h-0 flex items-center justify-center bg-gray-50 dark:bg-neutral-900"
  >
    <div class="text-center">
      <i
        class="bi bi-file-pdf text-gray-400 dark:text-neutral-600 text-6xl mb-4"
      ></i>
      <p class="text-gray-500 dark:text-neutral-400">PDF não disponível</p>
      @if (lesson.pdfUrl) {
      <p class="text-xs text-gray-400 dark:text-neutral-500 mt-2">
        URL inválida: {{ lesson.pdfUrl }}
      </p>
      }
    </div>
  </div>
  }
</div>
} @else {
<div
  class="w-full h-full flex items-center justify-center bg-gray-50 dark:bg-neutral-900"
>
  <div class="text-center">
    <i
      class="bi bi-file-pdf text-gray-400 dark:text-neutral-600 text-6xl mb-4"
    ></i>
    <p class="text-gray-500 dark:text-neutral-400">PDF não disponível</p>
  </div>
</div>
}
